import { FILE_TYPE_ICONS } from "../../../../../../constants";

const fileUploadTypes = [
  { type: "onboardingGuide", label: "Implementation steps/timeline" },
  { type: "permissions", label: "Details on requirements for a pilot/POC" },
  {
    type: "agreement",
    label: "Standard or proposed contract/licensing/subscription agreement",
  },
  {
    type: "technicalDocs",
    label:
      "Technical Documentation Access: Providing access to technical documentation",
  },
  {
    type: "demoLink",
    label:
      "Personal gmail account try out a demo or trial instance in the Cloud",
  },
  { type: "presentationDeck", label: "Presentation/deck/materials as a pre-read" },
];

export function getNoOfEmpLabel(list, id) {
  return list?.find((n) => n?.id === id)?.label;
}

export function getFileTypeIcon(file) {
  if (!file) return FILE_TYPE_ICONS.default;

  if (file?.[0] instanceof File) {
    if (!file[0]) return FILE_TYPE_ICONS.default;
    const tFile = file[0];
    const fileType = tFile?.name?.split(".")?.pop();
    return FILE_TYPE_ICONS?.[fileType] || FILE_TYPE_ICONS?.default;
  } else {
    return FILE_TYPE_ICONS?.default;
  }
}

export function getFileName(fileName) {
  return (
    fileUploadTypes?.find((fut) => fut?.type === fileName)?.label || fileName
  );
}

const ARRAY_PAYLOAD_FIELDS = ["technologyEnvironment", "keyCompetitors"];

function toArrayOfStrings(value) {
  if (value == null || value === "") return [];
  if (Array.isArray(value)) {
    return value.map((v) => String(v).trim()).filter(Boolean);
  }
  return String(value)
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);
}

export function getPayload({ formInputs, lists }) {
  const { technologyEnvironment, keyCompetitors, ...restFormInputs } =
    formInputs || {};

  return {
    ...restFormInputs,
    interestedId: Array.isArray(formInputs?.interestedId)
      ? formInputs?.interestedId?.map((k) => k?.label !== "")?.join(",")
      : formInputs?.interestedId,
    no_of_emp: lists?.no_of_emps?.data?.find(
      (n) => n?.id === formInputs?.no_of_emp
    )?.id,
    pricingStructure: Array.isArray(formInputs?.pricingStructure)
      ? formInputs?.pricingStructure?.join(",")
      : formInputs?.pricingStructure,
    keywords: Array.isArray(formInputs?.keywords)
      ? formInputs?.keywords?.map((k) => k?.label)?.join(",")
      : formInputs?.keywords,
    funding: formInputs?.funding ? formInputs?.funding : 0,
    revenue: formInputs?.revenue ? formInputs?.revenue : 0,
    technologyEnvironment: toArrayOfStrings(formInputs?.technologyEnvironment),
    keyCompetitors: toArrayOfStrings(formInputs?.keyCompetitors),
    profileCompleted: true,
  };
}

export function downloadFile(file) {
  const isFileArray = file?.length > 0 && file?.[0] instanceof File;
  const fileObj = isFileArray ? file?.[0] : null;

  const url = fileObj ? URL.createObjectURL(fileObj) : file;
  const a = document.createElement("a");
  a.href = url;
  a.download = fileObj ? fileObj.name : "download";
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  if (fileObj) {
    URL.revokeObjectURL(url);
  }
}